import MerchantRegistrationPage from '../../../../components/merchant/registration/MerchantRegistrationPage'

export default function Register() {
  return <MerchantRegistrationPage />
}
